import styled from 'styled-components';

export const Row = styled.div`
    border-bottom: 1px dotted ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    display: flex;
    flex-direction: row;
    font-size: 12px;
    margin-bottom: 10px;
    width: 100%;
`;

export const Text = styled.div`
    color: ${ ({ theme: { textColor } }) => textColor };
    flex-grow: 1;
    overflow: hidden;
    margin-right: 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Value = styled.div`
    color: ${ ({ theme: { primaryColor } }) => primaryColor };
    font-weight: 500;
    text-align: right;
`;
